import { useState } from "react";
import { FileText } from "lucide-react";
import { AuthImage } from "@/components/AuthImage";
import { useLang } from "@/context/LangContext";
import { api } from "@/lib/api";

const PdfButton = ({ path, testId }) => {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    const win = window.open("", "_blank");
    try {
      const r = await api.get(`/files/${path}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      if (win) win.location.href = url;
      else window.location.href = url;
    } catch {
      win?.close();
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={open} disabled={busy} data-testid={testId} className="inline-flex items-center gap-2 rounded-xl border border-border bg-muted px-4 py-3 text-sm font-semibold hover:bg-muted/70">
      <FileText className="h-5 w-5 text-primary" />{t("open_receipt")} (PDF)
    </button>
  );
};

export const ReceiptPreview = ({ path, type, className, testId = "receipt-preview" }) => {
  if (!path) return null;
  if (type === "application/pdf") return <PdfButton path={path} testId={testId} />;
  return <AuthImage path={path} alt="receipt" data-testid={testId} className={className} />;
};
